export const CHURN_REASONS_WITHOUT_SECONDARY = ['My company is closing']
